import React from "react";
import { UserRoles } from "../../models/playerModel";
import { Divider } from "../catalyst/divider";
import { TeamHeader } from "../teams/TeamHeader";
import { MemberRow } from "../teams/TeamMemberRow";
import { classNames } from "../../utils/appUtils";
import { Text } from "../catalyst/text";

const DraftingMyTeam: React.FC<any> = ({ myTeam, currentUser }) => {
  if (
    currentUser.role === UserRoles.admin ||
    currentUser.role === UserRoles.viewer
  ) {
    return null;
  }

  if (currentUser.role === UserRoles.player && !myTeam) {
    return null;
  }

  if (myTeam) {
    let playerNum = 0;
    return (
      <div className="bg-white dark:bg-gray-800 shadow rounded mb-5 flex flex-col h-full w-full">
        <div className="flex flex-col">
          <TeamHeader team={myTeam} />
          <Divider className="mb-1" />
          {myTeam.members &&
            myTeam.members.map((member: any, index: any) => (
              <div
                key={member.id}
                className={classNames(
                  index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
                  "flex items-center"
                )}
              >
                {member.isPlayer && (
                  <Text className="p-2 text-sm font-medium">
                    {++playerNum}.
                  </Text>
                )}
                <div className="flex-1">
                  <MemberRow member={member} />
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }

  return null;
};

export default DraftingMyTeam;
